
import {ShCompanySearch} from 'components/search-dropdown'

export default {
  components: {ShCompanySearch},
  emits: ['submit'],
  data() {
    return {
      company: undefined,
      loading: false,
      shared_company_id: undefined
    }
  },
  computed: {
    can_submit() {
      return !!this.shared_company_id
    }
  },
  methods: {
    open(data){
      this.shared_company_id = undefined
      this.company = data
      this.loading = false
      this.$refs.modal.open()
    },
    close(force) {
      if (this.loading && !force) return
      this.$refs.modal.close()
    },
    async submit() {
      this.loading = true
      const data = {
        source_id: this.company.id,
        target_id: this.shared_company_id
      }
      this.$emit('submit', data)
    }
  }
}
